import { render, staticRenderFns } from "./Commerce.vue?vue&type=template&id=01db70b9&lang=pug&"
import script from "./Commerce.vue?vue&type=script&lang=ts&"
export * from "./Commerce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports